import React from "react";
import { Link } from "react-router-dom";
import "./Withdrawal.css";

function Withdrawal() {
  return (
    <div className="MoneyWithdrawal">
      <div className="MoneyWithdrawal-inner">
        <h1>ととのう固定費のサブスクリプション解約について</h1>
        <p>
          お金に強くなるプラン（月間・年間）の解約は、Apple の App Store 経由で行います。
          開発者側で代行解約することはできません。
        </p>

        <h2>解約手順</h2>
        <ol>
          <li>iPhone の「設定」アプリを開く</li>
          <li>画面上部の Apple ID（自分の名前）をタップ</li>
          <li>「サブスクリプション」を選択</li>
          <li>一覧から「ととのう固定費」を選択</li>
          <li>「サブスクリプションをキャンセル」をタップ</li>
        </ol>

        <h2>解約後について</h2>
        <ul>
          <li>
            解約後も、現在の契約期間の終了まではお金に強くなるプランの機能を利用できる場合があります（App Store の表示に従います）。
          </li>
          <li>契約期間終了後は無料プランの範囲に戻ります。再度入会する場合は、その時点で App Store に表示されているプラン・料金が適用されます。</li>
          <li>
            料金の詳細は <Link to="/money/fee">料金ページ</Link>、条件は{" "}
            <Link to="/money/terms">利用規約</Link> をご確認ください。
          </li>
          <li>
            アカウントやクラウド上のデータを削除したい場合は、<Link to="/money/delete_app">アカウント削除</Link>
            を別途実行してください。
          </li>
        </ul>

        <h2>返金について</h2>
        <p>
          返金の可否・手続は Apple のポリシーに従います。開発者が App Store 外で返金処理を行うことはできません。
          返金を希望される場合は、<a href="https://reportaproblem.apple.com/">Apple のサポート</a>
          からお問い合わせください。
        </p>

        <p style={{ marginTop: 18, opacity: 0.85 }}>※ 本ページの内容は、必要に応じて更新されます。</p>
      </div>
    </div>
  );
}

export default Withdrawal;
